export const BUSINESS_APPLICATION_TERMS_TITLE = "Terms & Conditions";

export const BUSINESS_APPLICATION_TERMS_SECTIONS = [
  {
    title: "Information accuracy",
    body: "By registering a business through this platform, you confirm that the information you submit is accurate, complete, and authorized for use in connection with the business entity you are registering.",
  },
  {
    title: "Review and verification",
    body: "You acknowledge that approval, verification, or activation of business features may be subject to platform review and compliance checks.",
  },
  {
    title: "Business responsibilities",
    body: "You agree to keep your business profile information updated, to use the platform in good faith, and to ensure that business activities conducted through the system comply with applicable laws, regulations, and platform policies.",
  },
  {
    title: "Application decisions",
    body: "You understand that false, misleading, or unauthorized submissions may result in rejection, suspension, or removal of business access.",
  },
];

export const BUSINESS_APPLICATION_TERMS_BODY = BUSINESS_APPLICATION_TERMS_SECTIONS
  .map((section) => section.body)
  .join(" ");

export const BUSINESS_APPLICATION_TERMS_ACKNOWLEDGEMENT_LABEL = "I have read and agree to the Terms & Conditions for business registration.";

export const BUSINESS_APPLICATION_TERMS_REQUIRED_MESSAGE = "You must agree to the Terms & Conditions for business registration.";
